// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './story/'
import ElementUI from 'element-ui'


Vue.use(ElementUI);

import components from './components/'
import * as getData from './service/getData.js'

Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase()) // 首字母大写
  Vue.component(`v${name}`, components[key])
})

Vue.prototype.$checkPermissions = (val) => {
  if (!sessionStorage['permissions']) return false
  return JSON.parse(sessionStorage['permissions']).indexOf(val) > -1
};

router.beforeEach((to, from, next) => {
  let user = sessionStorage.getItem('user');
  let path = to.path;
  // console.log(!user && path != '/login')
  if (path != '/login') {
    getData.checkLogin().then((res) => {
      if (res.data.code != '1') {
        next({path: '/login'});
        sessionStorage.removeItem('user');
        return
      }
      sessionStorage.setItem('user', 'success');
      next();
    });
    return
  }
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js